import {
  CLEAN_NOTIFICATIONS,
  SET_NOTIFICATIONS,
  SET_PUSH_NOTIFICATIONS_AND_POP_UPS,
  SET_POP_UP
} from 'constants/types';

const INITIAL_STATE = {
  notifications: {},
  push_notifications_and_pop_ups: null,
  pop_up: null
};

function notificationsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload
      };
    case SET_PUSH_NOTIFICATIONS_AND_POP_UPS:
      return {
        ...state,
        push_notifications_and_pop_ups: action.payload
      };
    case SET_POP_UP:
      return {
        ...state,
        pop_up: action.payload
      };
    case CLEAN_NOTIFICATIONS:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export default notificationsReducer;
